import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../../Utils/GlobalUtils';

import Loading from '../../../Loading'

import styles from '../../../../styles/DynamicModal.module.css';

import IconContainer from '../../../IconContainer';
import { ReactComponent as XIcon } from '../../../../icons/x-close.svg';

const EditMainQualification = ({ closeModal, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        date_am_exam: '',
        admission_form: '',
        user_sdc: [],
    });
    const [specialDebtorsCategories, setSpecialDebtorsCategories] = React.useState([]);

    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-active-special-debtor-categories`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            const categories = response.data;

            axios.get(`/api/get-main-qualification?user_id=${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response2 => {
                const userData = response2.data;

                // фильтруем категории сразу
                const filteredCategories = categories.filter(cat =>
                    !userData.user_sdc.some(userCat => userCat.id === cat.id)
                );

                setSpecialDebtorsCategories(filteredCategories);
                setFormInfo(userData);
                setStatus(null);
            }).catch(error => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            });
        }).catch(error => {
            console.error(error);
        });


        axios.get(`/api/get-main-qualification?user_id=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setFormInfo(response.data);
            setStatus(null);
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.date_am_exam) {
            newErrors.date_am_exam = 'Обязательное поле';
        }
        if (formInfo.special_debtors_categories && (formInfo.special_debtors_categories.length < 2 || formInfo.special_debtors_categories.length > 150)) {
            newErrors.special_debtors_categories = 'Значение не может быть меньше 2 и более 150 символов';
        }
        if (formInfo.admission_form && (formInfo.admission_form.length > 50)) {
            newErrors.admission_form = 'Значение не может быть более 50 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const changeData = () => {
        axios.put(`/api/change-main-qualification`, {
            user_id: userId,
            date_am_exam: normalizeDate(formInfo.date_am_exam),
            user_sdc: formInfo.user_sdc,
            admission_form: formInfo.admission_form,
        }).then(() => {
            setStatus('Данные изменены');
            openTimeModal('Данные успешно сохранены', 'success');
            closeModal();
            onSuccess();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            changeData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Редактирование основных сведений о квалификации</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    {loading ? <Loading />
                    :
                    <>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата сдачи экзамена</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_am_exam?.split('T')[0]}
                                onChange={handleChange('date_am_exam')} 
                                className={errorsForm.date_am_exam ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                <p className='description'>Дата сдачи теоретического экзамена по подготовке арбитражных управляющих при Росреестре</p>
                                {errorsForm.date_am_exam && <div className='errorUnderInput'>{errorsForm.date_am_exam}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Специальные категории должников</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <p style={{fontSize: '14px' , paddingBottom: '5px'}}>Выбранные категории:</p>
                                
                                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center', gap: '10px'}}>
                                {formInfo.user_sdc.length === 0 ? (
                                <p className='description' style={{padding: '3px 0'}}>Категории не добавлены</p>
                                ) : (
                                formInfo.user_sdc.map((userSDC) => (
                                    <button 
                                    key={userSDC.id}
                                    className='tableButton'
                                    onClick={() => {
                                        setFormInfo(prev => ({
                                        ...prev,
                                        user_sdc: prev.user_sdc.filter(cat => cat.id !== userSDC.id)
                                        }));
                                        setSpecialDebtorsCategories(prev => [
                                        ...prev,
                                        { id: userSDC.id, category_name: userSDC.category_name }
                                        ]);
                                    }}
                                    >
                                        {userSDC.category_name}
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="minus-circle">
                                            <path fill="currentColor" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm4-9H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"></path>
                                        </svg>
                                    </button>
                                ))
                                )}
                                </div>

                                <p style={{fontSize: '14px', padding: '10px 0 5px 0', marginTop: '10px', borderTop: '1px solid #eee'}}>
                                    Добавить категории:
                                </p>

                                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center', gap: '10px'}}>
                                {specialDebtorsCategories.length===0 ? 
                                <p className='description' style={{padding: '3px 0'}}>Список пуст</p>
                                : specialDebtorsCategories.map((SDC) => (
                                    <button 
                                    key={SDC.id}
                                    className='tableButton'
                                    onClick={() => {
                                        setFormInfo(prev => ({
                                        ...prev,
                                        user_sdc: [...prev.user_sdc, { id: SDC.id, category_name: SDC.category_name }]
                                        }));
                                        setSpecialDebtorsCategories(prev => prev.filter(cat => cat.id !== SDC.id));
                                    }}
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="plus">
                                        <path fill="currentColor" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                                    </svg>
                                        {SDC.category_name}
                                    </button>
                                ))}
                                </div>
                                {errorsForm.special_debtors_categories && <div className='errorUnderInput'>{errorsForm.special_debtors_categories}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Форма допуска к государственной тайне</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <select value={formInfo.admission_form || ''} onChange={handleChange('admission_form')} required>
                                    <option value="">Отсутствует</option>
                                    <option value="Первая форма">Первая форма</option>
                                    <option value="Вторая форма">Вторая форма</option>
                                    <option value="Третья форма">Третья форма</option>
                                </select>
                                <p className='description'>Нажмите и выберите нужный вариант</p>
                                {errorsForm.admission_form && <div className='errorUnderInput'>{errorsForm.admission_form}</div>}
                            </div>
                        </div>
                    </div>
                    </>}
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditMainQualification;